import { render, staticRenderFns } from "./imageblock.vue?vue&type=template&id=46addbfa&scoped=true&"
import script from "./imageblock.vue?vue&type=script&lang=js&"
export * from "./imageblock.vue?vue&type=script&lang=js&"
import style0 from "./imageblock.vue?vue&type=style&index=0&id=46addbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46addbfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46addbfa')) {
      api.createRecord('46addbfa', component.options)
    } else {
      api.reload('46addbfa', component.options)
    }
    module.hot.accept("./imageblock.vue?vue&type=template&id=46addbfa&scoped=true&", function () {
      api.rerender('46addbfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/modular/imageblock.vue"
export default component.exports